import React from 'react'
import { Login } from 'react-admin'

const LoginPage = () => <Login backgroundImage="/background.jpg" />

export default LoginPage
